import { MODAL_MODES } from '../pages/team/constants'

export enum TEAM_MEMBER_USER_TYPES {
  DISPATCHER = 'dispatcher',
  DRIVER = 'driver',
  OWNER_OPERATOR = 'owner_operator',
}

export enum TEAM_MEMBER_ROLE_TYPES {
  ADMIN = 'admin',
  EMPLOYEE = 'employee',
}

export type TManageTeamMemberModalMode = typeof MODAL_MODES[keyof typeof MODAL_MODES]

export interface IMotorCarrierDetail {
  legalName: string
  motorCarrierId: number
  motorCarrierNumber: number
  dotNumber: number
  role?: TEAM_MEMBER_ROLE_TYPES
  userType?: TEAM_MEMBER_USER_TYPES
  checked?: boolean
}

export interface ITeamMember {
  id?: number // e.g. parent user id
  firstName: string
  lastName: string
  email?: string
  phone?: string
  cellPhone?: string
  motorCarrierDetails?: IMotorCarrierDetail[]
  canEdit?: boolean
  isExternal?: boolean
  smsStatusUpdatesEnabled?: boolean
}

export interface ITeamMembersResponse {
  teamMembers: ITeamMember[]
}

export interface ITeamMemberResponse {
  teamMember: ITeamMember
}
